/* RESPONSIBLE TEAM: team-automation-foundations */
import CustomBotSerializer from 'embercom/serializers/operator/custom-bot';

export default CustomBotSerializer.extend();
